// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolSearchBody = {
  query: string;
  sportKey?: string | null;
  leagueKey?: string | null;
  contestType?: "survivor" | "squares" | "stripCard" | "pickem" | null;
  cursor?: string | null;
  limit?: number | null;
};

export type typePoolSearchOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      poolId: string;
      poolRefId?: string | null;
      name: string;
      sportLabel: string;
      leagueLabel: string;
      visibility: "public" | "private";
      activeMemberCount: number;
      isMember: boolean;
      hasPendingInvite: boolean;
    }[];
    nextCursor?: string | null;
  };
};

export type typePoolSearchOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolSearchOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolSearchOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolSearchBody = {
  type: "object",
  properties: {
    query: { type: "string", maxLength: 3000, minLength: 1 },
    sportKey: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    leagueKey: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    contestType: {
      oneOf: [
        {
          type: "string",
          enum: ["survivor", "squares", "stripCard", "pickem"],
        },
        { enum: [null] },
      ],
    },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["query"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolSearch(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolSearchBody);
  }

  return async function postPoolSearch(
    payload: typePoolSearchBody,
  ): Promise<typePoolSearchOutput200 | typePoolSearchOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolSearch" failed before calling the network. #3fe5cc84a484`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#3fe5cc84a484" },
        },
        data: null,
      } as typePoolSearchOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/search`,
      httpMethod: "POST",
      options,
    })) as typePoolSearchOutput200 | typePoolSearchOutput400;
  };
}
